module.exports = __webpack_public_path__ + "img/sulv_4.f24ec4ee.jpg";